import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Footer from './components/Footer';
import Testimonial from './components/Testimonial';
import ServiceDetail from './pages/ServiceDetail';

function App() {
    return (
        <div
            style={{
                backgroundImage: "url('../images/background.jpg')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed",
                backgroundPosition: "center",
                minHeight: "100vh",
            }}
        >
            <Router>
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/service-detail" element={<ServiceDetail />} />
                </Routes>
                <Testimonial
                    style={{ marginTop: "0",
                        padding: "10px 0",
                        marginBottom: "10px 0",}}/> {/* Ensure this is only here */}
                <footer id="contact" style={{ marginTop: "0px",}}>
                    <Footer />
                </footer>
            </Router>
        </div>
    );
}

export default App;
